<script setup lang="ts">
import { legalLinks } from '~/content/legal'

const route = useRoute()
const currentYear = new Date().getFullYear()
const { isPro } = useSiteTheme()

const { visible, sectionRef } = useScrollReveal(0.1)

const links = [
  { label: 'Particuliers', to: '/' },
  { label: 'Entreprises', to: '/entreprises' }
]

const isActiveLink = (to: string) => {
  if (to === '/') {
    return route.path === '/'
  }

  return route.path.startsWith(to)
}
</script>

<template>
  <footer ref="sectionRef" :class="[
    'text-white',
    isPro ? 'bg-gradient-to-r from-red-600 to-orange-700' : 'bg-sky-700'
  ]">
    <div class="container mx-auto px-4 py-16">
      <div class="reveal flex flex-col items-center gap-10 lg:flex-row lg:justify-between" :class="{ 'is-visible': visible }">
        <NuxtLink to="/" aria-label="Retour à l’accueil" class="flex items-center">
          <NuxtImg
            src="/svg/logo.svg"
            alt="Logo SARL Deboosere"
            width="360"
            height="206"
            class="h-20 w-auto brightness-0 invert"
          />
        </NuxtLink>

        <nav aria-label="Navigation du pied de page">
          <ul class="flex flex-wrap items-center justify-center gap-8 text-sm font-medium">
            <li v-for="link in links" :key="link.to">
              <NuxtLink
                :to="link.to"
                :class="[
                  'transition',
                  isActiveLink(link.to)
                    ? 'text-white'
                    : 'text-white/90',
                  isPro
                    ? 'hover:text-white'
                    : 'hover:text-sky-200'
                ]"
              >
                {{ link.label }}
              </NuxtLink>
            </li>
          </ul>
        </nav>

        <a
          href="https://www.facebook.com/p/Deboosere-Chauffage-sanitaire-100063721472973/"
          target="_blank"
          rel="noopener"
          aria-label="Facebook Deboosere"
          class="transition hover:scale-110"
        >
          <Icon name="mdi:facebook" class="text-4xl text-white" />
        </a>
      </div>

      <nav aria-label="Informations légales" class="mt-12 border-t border-white/20 pt-6">
        <ul class="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/90">
          <li v-for="link in legalLinks" :key="link.to">
            <NuxtLink
              :to="link.to"
              :class="['transition', isPro ? 'hover:text-white' : 'hover:text-sky-200']"
            >
              {{ link.label }}
            </NuxtLink>
          </li>
        </ul>
      </nav>

      <div class="mt-6 text-center text-sm text-white/90">
        © {{ currentYear }} Deboosere Chauffage Sanitaire — propulsé parmi les étoiles par
        <a
          href="https://astrocom.fr/"
          target="_blank"
          rel="noopener"
          :class="[
            'font-semibold text-white transition',
            isPro ? 'hover:underline' : 'hover:text-sky-200'
          ]"
        >
          Astrocom
        </a>
      </div>
    </div>
  </footer>
</template>